import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  requestCertificateDetailFailed,
  requestCertificateDetailSuccess,
  requestCertificateReferencesFailed,
  requestCertificateReferencesSuccess,
  requestCertificatesFailed,
  requestCertificatesSuccess
} from '../../actions/resources/Certificate';
import CertificateAPI from '../../api/resources/Certificate';
import * as Constants from '../../constants/resources';
import { CertificateReferencesPayload } from '../../types/resources/State';

function* getCertificates(data: {
  payload: { from: number; pageSize: number; filter: string };
  type: Constants.CERTIFICATES;
}) {
  try {
    const certificates = yield call(
      CertificateAPI.getCertificates,
      data.payload
    );
    yield put(requestCertificatesSuccess(certificates));
  } catch (e) {
    yield put(requestCertificatesFailed());
  }
}

function* watchForCertificates() {
  yield takeLatest(Constants.CERTIFICATES, getCertificates);
}

function* getCertificateDetail(certificateVMID: any) {
  try {
    const certificateDetail = yield call(
      CertificateAPI.getCertificateDetail,
      certificateVMID
    );
    yield put(requestCertificateDetailSuccess(certificateDetail));
  } catch (e) {
    yield put(requestCertificateDetailFailed());
  }
}

function* watchForCertificateDetail() {
  yield takeLatest(Constants.CERTIFICATE_DETAIL, getCertificateDetail);
}

function* getCertificateReferences(payload: CertificateReferencesPayload) {
  try {
    const certificateReferences = yield call(
      CertificateAPI.getCertificateReferences,
      payload
    );
    yield put(requestCertificateReferencesSuccess(certificateReferences));
  } catch (e) {
    yield put(requestCertificateReferencesFailed());
  }
}

function* watchForCertificateReferences() {
  yield takeLatest(Constants.CERTIFICATE_REFERENCES, getCertificateReferences);
}

export default function* homeSaga() {
  yield all([
    watchForCertificates(),
    watchForCertificateDetail(),
    watchForCertificateReferences()
  ]);
}
